(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[794],{

/***/ 40794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ help_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./src/common/components/faqs/index.tsx + 2 modules
var faqs = __webpack_require__(12842);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var dist = __webpack_require__(79749);
// EXTERNAL MODULE: ./src/common/utils/config/index.ts
var config = __webpack_require__(79354);
;// CONCATENATED MODULE: ./src/common/components/help-page/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  padding-top: 15px;\n  max-width: ",
        ";\n  margin: ",
        ";\n  padding: ",
        ";\n\n  @media screen and (min-width: 768px) {\n    padding: 0;\n    max-width: unset;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  width: inherit;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 1.125rem;\n  line-height: 1.5rem;\n  margin-top: 16px;\n\n  @media screen and (min-width: 768px) {\n    font-weight: 700;\n    font-size: 1.625rem;\n    line-height: 2.25rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  padding: 10px 0 6px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0 32px 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 768px) {\n    max-width: 1200px;\n    margin: auto;\n    padding: 24px 20px;\n    background: white;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 768px) {\n    padding: 24px 20%;\n    background: url(",
        ");\n    background-repeat: no-repeat;\n    background-color: #f8fdff;\n    background-size: 100%;\n    ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var HelpPageContainer = dist.styled.div(_templateObject(), function(props) {
    return props.maxWidth || "480px";
}, function(props) {
    return props.margin || "auto";
}, function(props) {
    return props.padding || "20px";
});
var ButtonContainer = dist.styled.div(_templateObject1());
var Title = dist.styled.div(_templateObject2());
var Desc = dist.styled.div(_templateObject3());
var SkeletonContainer = dist.styled.div(_templateObject4());
var IconContainer = dist.styled.div(_templateObject5());
var HelpNavbar = dist.styled.div(_templateObject6());
var HelpContent = dist.styled.div(_templateObject7(), config/* INTERNATIONAL_DESKTOP_ASSETS.JOURNEY_BACKGROUND */.FJ.JOURNEY_BACKGROUND, function(props) {
    return props && props.contentStyles;
});

// EXTERNAL MODULE: ./src/common/utils/serverConfig/index.ts
var serverConfig = __webpack_require__(44718);
// EXTERNAL MODULE: ./src/common/utils/api/request.ts
var request = __webpack_require__(55978);
// EXTERNAL MODULE: ./src/common/utils/api/urls.ts + 1 modules
var urls = __webpack_require__(92310);
// EXTERNAL MODULE: ./src/common/components/error-page/index.tsx + 2 modules
var error_page = __webpack_require__(79383);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var react_loading_skeleton_dist = __webpack_require__(50549);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(34714);
;// CONCATENATED MODULE: ./src/common/components/help-page/Skeleton.tsx




var Index = function() {
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SkeletonContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_loading_skeleton_dist/* default */.Z, {
                height: "24px",
                borderRadius: "8px"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_loading_skeleton_dist/* default */.Z, {
                height: "20px",
                borderRadius: "8px"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_loading_skeleton_dist/* default */.Z, {
                height: "48px",
                borderRadius: "8px"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_loading_skeleton_dist/* default */.Z, {
                height: "32px",
                borderRadius: "8px"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_loading_skeleton_dist/* default */.Z, {
                height: "140px",
                borderRadius: "8px"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_loading_skeleton_dist/* default */.Z, {
                height: "140px",
                borderRadius: "8px"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_loading_skeleton_dist/* default */.Z, {
                height: "140px",
                borderRadius: "8px"
            })
        ]
    });
};
/* harmony default export */ var Skeleton = (Index);

// EXTERNAL MODULE: ./src/common/utils/segment/types.ts
var types = __webpack_require__(19659);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.acko-analytics/dist/index.js
var building_blocks_ui_acko_analytics_dist = __webpack_require__(94262);
// EXTERNAL MODULE: ./src/common/custom-hooks/index.ts
var custom_hooks = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/international-insurance/config/index.ts
var international_insurance_config = __webpack_require__(56073);
// EXTERNAL MODULE: ./src/common/styles/index.ts
var common_styles = __webpack_require__(31065);
// EXTERNAL MODULE: ./src/common/utils/responsive/index.tsx
var responsive = __webpack_require__(7010);
// EXTERNAL MODULE: ./src/common/context-providers/user-provider.tsx
var user_provider = __webpack_require__(86089);
;// CONCATENATED MODULE: ./src/common/components/help-page/index.tsx
/* eslint-disable @next/next/no-img-element */ 





















var HelpPage = function(param) {
    var _styles = param.styles, styles = _styles === void 0 ? {} : _styles, _showFaqsOnly = param.showFaqsOnly, showFaqsOnly = _showFaqsOnly === void 0 ? false : _showFaqsOnly, _hideErrorView = param.hideErrorView, hideErrorView = _hideErrorView === void 0 ? false : _hideErrorView;
    var ref, ref1;
    var userDetails = (0,user_provider/* useUser */.a)();
    var router = (0,next_router.useRouter)();
    var journeyId = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.journeyId;
    var fromPage = (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.from) || "";
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref2 = (0,compat_module.useState)(null), helpData = ref2[0], setHelpData = ref2[1];
    var ref3 = (0,compat_module.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,compat_module.useState)(null), isError = ref4[0], setIsError = ref4[1];
    var pushRoute = (0,custom_hooks/* useRouterPush */.E3)();
    (0,compat_module.useEffect)(function() {
        getFaqs();
    }, []);
    (0,compat_module.useEffect)(function() {
        if ( true && !!helpData) {
            (0,building_blocks_ui_acko_analytics_dist.waitForAnalyticsLoad)().then(function() {
                (0,building_blocks_ui_acko_analytics_dist.pageEvent)(types/* TravelInsuranceViewEvents.VIEW_PAGE_INT_HELP */.e2.VIEW_PAGE_INT_HELP, (0,_object_spread/* default */.Z)({
                    journey: "buy",
                    product: "travel",
                    sub_product_name: "international_travel",
                    email: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.email) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.email : undefined,
                    phone: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.phone) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.phone : undefined,
                    page: types/* TravelInsurancePages.INT_TRAVEL_HELP_SCREEN */.I6.INT_TRAVEL_HELP_SCREEN,
                    from_page: fromPage ? international_insurance_config/* StateToPageMapper */.Vn[fromPage] : undefined,
                    proposal_id: journeyId
                }, (0,custom_hooks/* getUtmParams */.We)()));
            });
        }
    }, [
        helpData
    ]);
    var getFaqs = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, res, error, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,request/* getRequest */.A_)("".concat((0,serverConfig/* getDomainOrigin */.IY)()).concat(urls/* internationalTravelUrls.generic */.H7.generic(urls/* UrlType.FETCH_FAQS */.k2.FETCH_FAQS)))
                        ];
                    case 2:
                        res = _state.sent();
                        setIsLoading(false);
                        setIsError(null);
                        setHelpData(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setIsLoading(false);
                        setIsError(error);
                        if ( true && !!(window === null || window === void 0 ? void 0 : window.newrelic)) {
                            ;
                            window === null || window === void 0 ? void 0 : (ref1 = window.newrelic) === null || ref1 === void 0 ? void 0 : ref1.noticeError(error, {
                                url: window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.href,
                                journeyId: journeyId
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getFaqs() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBack = function() {
        var ref, ref1;
        (0,building_blocks_ui_acko_analytics_dist.trackEvent)(types/* TravelInsuranceTrackEvents.TAP_BTN_INT_BACK */.G$.TAP_BTN_INT_BACK, (0,_object_spread/* default */.Z)({
            journey: types/* TRAVEL.JOURNEY */.E8.JOURNEY,
            product: types/* TRAVEL.PRODUCT */.E8.PRODUCT,
            sub_product_name: types/* TRAVEL.SUB_PRODUCT_NAME */.E8.SUB_PRODUCT_NAME,
            email: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.email) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.email : undefined,
            phone: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.phone) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.phone : undefined,
            proposal_id: journeyId,
            page: types/* TravelInsurancePages.INT_TRAVEL_HELP_SCREEN */.I6.INT_TRAVEL_HELP_SCREEN,
            from_page: fromPage ? international_insurance_config/* StateToPageMapper */.Vn[fromPage] : undefined
        }, (0,custom_hooks/* getUtmParams */.We)()));
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.policyId) !== undefined) {
            var ref2;
            return pushRoute("/pdp/".concat(router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.policyId));
        }
        return pushRoute("/".concat(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.journeyId));
    };
    if (!!isError && !hideErrorView) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(error_page/* default */.Z, {
            error: isError,
            handleClick: function() {
                return handleBack;
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(HelpPageContainer, {
        children: [
            showFaqsOnly ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HelpNavbar, {
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconContainer, {
                    onClick: handleBack,
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("img", {
                        src: config/* ASSETS.BACK_ARROW */.ou.BACK_ARROW,
                        width: "24px",
                        height: "24px",
                        alt: "back"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconContainer, {
                    onClick: function() {
                        return router === null || router === void 0 ? void 0 : router.push("/");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("img", {
                        src: config/* ASSETS.ACKO_LOGO_DARK */.ou.ACKO_LOGO_DARK,
                        width: "auto",
                        height: "24px",
                        alt: "back"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HelpContent, {
                contentStyles: styles === null || styles === void 0 ? void 0 : styles.contentStyles,
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Skeleton, {}) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                    children: [
                        helpData && !showFaqsOnly && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Title, {
                                    children: helpData === null || helpData === void 0 ? void 0 : helpData.page_title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(common_styles/* Row */.X2, {
                                    align: "center",
                                    margin: "24px 0 0 0",
                                    gap: "24px",
                                    paddingRight: "0",
                                    paddingBottom: "0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                            src: config/* ASSETS.ENVELOPE */.ou.ENVELOPE,
                                            height: "20px",
                                            width: "20px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(common_styles/* Text */.xv, {
                                            size: "1rem",
                                            weight: "600",
                                            lineHeight: "1.375rem",
                                            color: "#104EA3",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                href: "mailto:".concat(helpData === null || helpData === void 0 ? void 0 : helpData.support_email_address),
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: helpData === null || helpData === void 0 ? void 0 : helpData.support_email_address
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(common_styles/* Row */.X2, {
                                    margin: "20px 0 0 0",
                                    paddingRight: "0",
                                    paddingBottom: "0",
                                    gap: "24px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                            src: config/* ASSETS.PHONE */.ou.PHONE,
                                            height: "20px",
                                            width: "20px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(common_styles/* Row */.X2, {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(common_styles/* Text */.xv, {
                                                    size: "1rem",
                                                    weight: "600",
                                                    lineHeight: "1.375rem",
                                                    color: "#104EA3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                        href: "tel:".concat(helpData === null || helpData === void 0 ? void 0 : helpData.domestic_phone_number),
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        children: helpData === null || helpData === void 0 ? void 0 : helpData.domestic_phone_number
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(faqs/* default */.Z, {
                            title: helpData === null || helpData === void 0 ? void 0 : helpData.page_sub_title,
                            helpData: helpData === null || helpData === void 0 ? void 0 : helpData.faq_list,
                            styles: styles
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var help_page = (HelpPage);


/***/ }),

/***/ 34714:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 50549:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* unused harmony export SkeletonTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
'use client';


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__["default"].createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__["default"].useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(react__WEBPACK_IMPORTED_MODULE_0__["default"].Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (React.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ })

}]);